import React from 'react'
import { Link } from 'react-router-dom'

import ArrowRightIcon from '../../../assets/icons/arrow-head-right.svg?react'

type Props = { links: { label: string | React.ReactNode, to: string }[] }
const NavigationBreadcrumbs: React.FC<Props> = ({ links }) => {
  return (
    <div className='flex gap-x-2'>
      {links.map((link, index) => (
        <div key={index} className='flex gap-x-1 items-center'>
          {index > 0 && <ArrowRightIcon className='w-auto h-3 stroke-deep-green mr-2 ml-1' />}
          <Link className='text-xs sm:text-sm text-black font-light' to={link.to}>{link.label}</Link>
        </div>
      ))}
    </div>
  )
}

export default NavigationBreadcrumbs
